// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__gVQ7z","inner":"NotFound_inner__YtWkI","link_wrapper":"NotFound_link_wrapper__XJO0X"};